import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonBlack, ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import { ScheduleGroupClassModal } from '../../components/schedule_group_class';
import User from '../../images/user.jpg';
import { IoLibraryOutline } from 'react-icons/io5';
import ProgressBarComponent from '../../components/progess_bar'
import { ClockLoader } from 'react-spinners';
import { ScheduleClassModal } from '../../components/schedule_class_modal'

function MyTutorsScreen() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [loadingClasses, setLoadingClasses] = useState(true);
    const [enrolledClasses, setEnrolledClasses] = useState([]);
    const { setTostMessage } = useContext(TostMessageContext);
    const [showGroupScheduleModal, setShowGroupScheduleModal] = useState(false)
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    const [profileData, setProfileData] = useState({ 'f_name': '', 'l_name': '', 'm_name': '', 'streak': '', 'dob': '', 'classes': [], 'attendance': 0 });
    const [groupScheduleDetails, setGroupScheduleDetails] = useState({});
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [paymentModalDetails, setPaymentModalDetails] = useState({});


    useEffect(() => {
        getClasses();
    }, [])

    const getClasses = async () => {
        setLoadingClasses(true);
        try {
            const response = await axios.get(base_url + '/manage-child/fetch_tutor_accounts.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setEnrolledClasses(response.data.results);
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

    const updateStatus = async (account_type, action, account_id) => {
        setLoadingClasses(true);
        const formData = new FormData();
        formData.append("account_id", account_id);
        formData.append("action", action);
        formData.append("account_type", account_type);

        try {
            const response = await axios.post(base_url + '/manage-child/disable-account.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "success",
                    message: response.data.response,
                });
                window.location.reload()
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full flex flex-row justify-between'>
                    {loadingClasses ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={loadingClasses}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    ) : (
                    <div className="w-full lg:w-[100%] p-0 lg:p-6 space-y-6 min-h-screen">
                        <div className="flex flex-wrap justify-between items-center mb-6">
                            <h2 className="text-xl font-semibold">Tutor Accounts</h2>
                            <div className="flex w-full lg:w-auto flex-row lg:flex-row items-center lg:items-end justify-between gap-4 mt-4 md:mt-0">
                                <button onClick={() => navigate('/all-tutors/applications')} className={`bg-[#241D0C] text-yellow px-6 py-2 rounded-md font-medium text-sm`}>
                                    View Applications
                                </button>
                                <button onClick={() => navigate('/all-tutors/create')} className={`bg-yellow px-6 py-2 rounded-md font-medium text-sm`}>
                                    Add New Tutor
                                </button>
                            </div>
                        </div>
                        <div className='overflow-x-auto'>
                            <table className="w-full table-auto border-collapse text-sm">
                                <thead className="bg-gray-50 border-b">
                                <tr>
                                    <th className="p-4">
                                        <div className="flex items-center gap-1">#</div>
                                    </th>
                                    <th className="text-left px-4 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Name</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Classes</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Joined Since</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Action</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Last Login</div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="text-gray-700">
                                    {enrolledClasses?.map((row, index) => (
                                        <tr
                                        key={index}
                                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                        >
                                            <td className="px-4 py-2">
                                                {++index}
                                            </td>
                                            <td className="px-4 py-2 font-semibold">
                                                {row.account_name}
                                            </td>
                                            <td className="px-4 py-2 font-semibold">
                                                {row.no_of_classes}
                                            </td>
                                            <td className="px-3 py-2">
                                                {row.joined_date}
                                            </td>
                                            <td className="px-2 py-2">
                                                {row.status ? (
                                                    <button onClick={() => window.confirm('Are you sure you want to disable this tutor account?') && updateStatus('tutor', 'disable', row.account_id)} className='px-4 py-2 bg-[#d40000] m-1 rounded-[5px] text-white'>Disable</button>
                                                ) : (
                                                    <button onClick={() => updateStatus('tutor', 'enable', row.account_id)} className='px-4 py-2 bg-yellow m-1 rounded-[5px] text-dark'>Enable</button>
                                                )}
                                                <button onClick={() => userProfile?.admin_role == "super-admin" ? navigate('/earnings', {state: { tutor_id: row.account_id }}) : null} className={`px-4 py-2 bg-yellow m-1 rounded-[5px] text-dark ${userProfile?.admin_role !== "super-admin" && 'cursor-not-allowed opacity-[0.7]'}`}>Earnings</button>
                                                <button onClick={() => userProfile?.admin_role == "super-admin" ? navigate('/all-tutors/profile-settings', {state: { tutor_id: row.account_id }}) : null} className={`px-4 py-2 bg-yellow m-1 rounded-[5px] text-dark ${userProfile?.admin_role !== "super-admin" && 'cursor-not-allowed opacity-[0.7]'}`}>Settings</button>
                                            </td>
                                            <td className="px-3 py-2">
                                                {row.last_login}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default MyTutorsScreen;
